import { LayoutAlternative, Project } from '@thive/fddm-types';
import { create } from 'zustand';
import { devtools } from 'zustand/middleware';
import { DEVTOOLS_OPTIONS } from '@/modules/debug/constants/zustand';

interface State {
  activeProject:
    | {
        status: 'not_loaded' | 'loading';
        data: null;
      }
    | {
        status: 'loaded';
        data: Project;
      };
  activeLayoutAlternative:
    | {
        status: 'not_loaded' | 'loading';
        data: null;
      }
    | {
        status: 'loaded';
        data: LayoutAlternative;
      };
}

interface Methods {
  setActiveProject(project: Project): void;
  setActiveLayoutAlternative(ids: LayoutAlternative): void;
  reset(): void;
}

const INITIAL_STATE: State = {
  activeProject: {
    status: 'not_loaded',
    data: null,
  },
  activeLayoutAlternative: {
    status: 'not_loaded',
    data: null,
  },
};

interface IStore extends State, Methods {}

// TODO: this should be merged with the app store / app service

export const useAppMetaStore = create<IStore>()(
  devtools(
    (set, get) => ({
      ...INITIAL_STATE,

      setActiveProject(project) {
        set(
          {
            activeProject: {
              status: 'loaded',
              data: project,
            },
          },
          undefined,
          {
            type: 'activeProject/set',
            ...DEVTOOLS_OPTIONS,
          },
        );
      },

      resetActiveProject() {
        set(
          {
            activeProject: {
              status: 'not_loaded',
              data: null,
            },
          },
          undefined,
          {
            type: 'activeProject/reset',
            ...DEVTOOLS_OPTIONS,
          },
        );
      },

      setActiveLayoutAlternative(layoutAlternative) {
        set(
          {
            activeLayoutAlternative: {
              status: 'loaded',
              data: layoutAlternative,
            },
          },
          undefined,
          {
            type: 'activeLayoutAlternative/set',
            ...DEVTOOLS_OPTIONS,
          },
        );
      },

      resetActiveLayoutAlternative() {
        set(
          {
            activeLayoutAlternative: {
              status: 'not_loaded',
              data: null,
            },
          },
          undefined,
          {
            type: 'activeLayoutAlternative/reset',
            ...DEVTOOLS_OPTIONS,
          },
        );
      },

      reset() {
        set(INITIAL_STATE, undefined, { type: 'reset', ...DEVTOOLS_OPTIONS });
      },
    }),
    { store: 'appMetaData', ...DEVTOOLS_OPTIONS },
  ),
);
